function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
import dayjs from 'dayjs';
import { TOKEN_REFRESH_EXPIRATION, SCALES_BY_ID } from "../constants";
var displayFormatEn = 'DD MMM YYYY';
var displayFormatJa = 'MM/DD/YYYY';
var graphDateEn = 'MM/DD/YY';
var graphDateJa = 'YY/MM/DD';
export function pxToRem(value) {
  return "".concat(value / 16, "rem");
}
export var getDateFormat = function getDateFormat(date, locale, format) {
  if (locale === 'en') {
    return dayjs(date).format(format || displayFormatEn);
  }
  if (locale === 'ja') {
    return dayjs(date).format(format || displayFormatJa);
  }
  return dayjs(date).format(format);
};
export var getDateFormatGraph = function getDateFormatGraph(date, locale, format) {
  if (locale === 'en') {
    return dayjs(date).format(format || graphDateEn);
  }
  if (locale === 'ja') {
    return dayjs(date).format(format || graphDateJa);
  }
  return dayjs(date).format(format);
};
export var LoggedOutTextFieldStyles = {
  margin: '5px 0',
  width: '100%',
  '& .MuiFormLabel-root.Mui-focused': {
    color: 'red !important'
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: 'red',
      borderWidth: 1
    },
    '&.Mui-focused label': {
      color: 'red'
    }
  },
  '& .MuiOutlinedInput-input': {
    backgroundColor: 'white'
  },
  '& .Mui-error': {
    backgroundColor: 'transparent'
  }
};
export var TablePaginationStyles = function TablePaginationStyles(theme) {
  return {
    color: theme.palette.font.primary,
    '& svg': {
      color: theme.palette.font.primary
    }
  };
};
export var controlLabelStyles = function controlLabelStyles(theme) {
  return {
    fontWeight: 400,
    paddingBottom: '5px',
    color: theme.palette.font.primary,
    letterSpacing: '0.33px',
    opacity: 0.8
  };
};
export var controlFormStyles = function controlFormStyles(theme) {
  return _defineProperty({
    background: theme === null || theme === void 0 ? void 0 : theme.palette.inputField.primary,
    borderRadius: '4px',
    color: theme === null || theme === void 0 ? void 0 : theme.palette.font.primary,
    fontWeight: '600',
    letterSpacing: '0.33px',
    opacity: '0.8',
    '&:focus': {
      boxShadow: 'none !important'
    },
    '& div > .MuiAutocomplete-endAdornment > button > span': {
      color: theme.palette.font.primary
    },
    '&.Mui-focused': {
      border: 'none'
    },
    '& .MuiSvgIcon-root': {
      color: theme === null || theme === void 0 ? void 0 : theme.palette.font.primary
    },
    '& input::placeholder': {
      fontSize: '20px'
    },
    fontSize: pxToRem(16)
  }, theme.breakpoints.down('md'), {
    fontSize: pxToRem(12)
  });
};
export var infoIconStyles = function infoIconStyles(theme) {
  return {
    color: theme.palette.font.primary,
    position: 'absolute',
    top: '10px',
    right: '10px'
  };
};
export var drawerContentStyles = function drawerContentStyles(theme) {
  return {
    width: '60vw',
    maxWidth: '1000px',
    background: theme === null || theme === void 0 ? void 0 : theme.palette.content.secondary,
    color: theme === null || theme === void 0 ? void 0 : theme.palette.font.primary,
    padding: '2.8em 2.8em 2.8em',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  };
};
export var brandBoxShadow = '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)';
export var FONT_MODES = {
  small: 12,
  medium: 16,
  large: 18
};
export var FONT_SIZES = {
  small: {
    xs: '11px',
    sm: '12px',
    m: '13px',
    ml: '14px',
    l: '15px',
    xl: '16px',
    xxl: '17px',
    xxxl: '18px',
    smTitle: '22px',
    mTitle: '24px',
    xxxTitle: '30px',
    "super": '40px'
  },
  medium: {
    xs: '13px',
    sm: '14px',
    m: '15px',
    ml: '16px',
    l: '17px',
    xl: '18px',
    xxl: '19px',
    xxxl: '20px',
    smTitle: '23px',
    mTitle: '26px',
    xxxTitle: '32px',
    "super": '42px'
  },
  large: {
    xs: '15x',
    sm: '16px',
    m: '17px',
    ml: '18px',
    l: '19px',
    xl: '20px',
    xxl: '21px',
    xxxl: '22px',
    smTitle: '24px',
    mTitle: '28px',
    xxxTitle: '34px',
    "super": '44px'
  }
};
export var getBrowser = function getBrowser() {
  // FROM https://developer.mozilla.org
  if (window && window.navigator) {
    var sBrowser;
    var sUsrAg = navigator.userAgent;
    // The order matters here, and this may report false positives for unlisted browsers.
    if (sUsrAg.indexOf('Firefox') > -1) {
      sBrowser = 'Mozilla Firefox';
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1) {
      sBrowser = 'Opera';
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (sUsrAg.indexOf('Trident') > -1) {
      sBrowser = 'Microsoft Internet Explorer';
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf('Edge') > -1) {
      sBrowser = 'Microsoft Edge';
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf('Chrome') > -1) {
      sBrowser = 'Google Chrome or Chromium';
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf('Safari') > -1) {
      sBrowser = 'Apple Safari';
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
      sBrowser = 'unknown';
    }
    return sBrowser;
  }
  return '';
};
export var getQueryParam = function getQueryParam(key) {
  var queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(key);
};
export function getBrowserLanguage() {
  var browserLang;
  // @ts-expect-error `navigator.userLanguage`, `navigator.browserLanguage`, and `navigator.systemLanguage` are not
  // part of the ECMAScript specification and are platform dependent.
  var userLang = window.navigator.language || window.navigator.userLanguage || window.navigator.browserLanguage || window.navigator.systemLanguage;
  if (userLang.toLowerCase() === 'ja' || userLang.toLowerCase() === 'ja-jp') {
    browserLang = '日本語';
  } else if (userLang.toLowerCase() === 'es' || userLang.toLowerCase() === 'es-419' || userLang.toLowerCase() === 'es-ar' || userLang.toLowerCase() === 'es-bo' || userLang.toLowerCase() === 'es-cl' || userLang.toLowerCase() === 'es-co' || userLang.toLowerCase() === 'es-cr' || userLang.toLowerCase() === 'es-do' || userLang.toLowerCase() === 'es-ec' || userLang.toLowerCase() === 'es-es' || userLang.toLowerCase() === 'es-gt' || userLang.toLowerCase() === 'es-hn' || userLang.toLowerCase() === 'es-mx' || userLang.toLowerCase() === 'es-ni' || userLang.toLowerCase() === 'es-pa' || userLang.toLowerCase() === 'es-pe' || userLang.toLowerCase() === 'es-pr' || userLang.toLowerCase() === 'es-py' || userLang.toLowerCase() === 'es-sv' || userLang.toLowerCase() === 'es-uy' || userLang.toLowerCase() === 'es-ve') {
    browserLang = 'Español';
  } else {
    browserLang = 'English';
  }
  return browserLang;
}
export function getDisplayLocaleName(firstName, lastName, language) {
  return language === 'ja' ? "".concat(lastName, " ").concat(firstName) : "".concat(firstName, " ").concat(lastName);
}
export var hasCookiesDisabled = function hasCookiesDisabled() {
  return !window.navigator.cookieEnabled;
};
export function validateEmail(email) {
  if (email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  return false;
}
export function validatePassword(pass) {
  var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W\_])[a-zA-Z0-9\W\_]{8,9999999}$/;
  return reg.test(pass);
}
export function parseErrorMessage(error, locale) {
  var message = locale === '日本語' ? error.message_ja : error.message_en;
  return _objectSpread({
    message: message,
    name: error.error
  }, error);
}
export var isPrivateMode = function () {
  var isPrivate;
  try {
    localStorage.setItem('localStorage', '1');
    localStorage.removeItem('localStorage');
    isPrivate = false;
  } catch (e) {
    isPrivate = true;
  }
  return isPrivate;
}();
export function saveLocal(key, value) {
  if (hasCookiesDisabled()) {
    return;
  }
  if (!isPrivateMode) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}
export function getLocal(key) {
  if (hasCookiesDisabled()) {
    return null;
  }
  if (!isPrivateMode) {
    var value = localStorage.getItem(key);
    if (value) {
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    }
    return null;
  }
  return null;
}
export var storeRefreshTokenExpiration = function storeRefreshTokenExpiration(token) {
  if (!token || !token.access_token) return;
  // Note we multiply the unix exp by 1000 to convert to milliseconds
  saveLocal(TOKEN_REFRESH_EXPIRATION, new Date().getTime() + token.refresh_expires_in * 1000);
};
export var capitalize = function capitalize(str) {
  var lower = str.toLowerCase();
  return str.charAt(0).toUpperCase() + lower.slice(1);
};
export var getScaleNameById = function getScaleNameById(scale_id) {
  return SCALES_BY_ID[scale_id].split(' ').map(function (word) {
    return capitalize(word);
  }).join('');
};

/**
 * Retrieves the environment based on the current hostname.
 *
 * @returns {string} The environment ('prod', 'staging', or 'dev').
 */
export var getEnvironment = function getEnvironment() {
  var hostname = window.location.hostname;
  if (hostname.includes('attuned.ai') && !hostname.startsWith('dev-') && !hostname.startsWith('staging-')) {
    return 'prod';
  }
  if (hostname.includes('staging')) {
    return 'staging';
  }
  return 'dev';
};

/**
 * The value of the NODE_ENV environment variable.
 *
 * @returns {string}
 */
export var NODE_PROCESS_ENVIRONMENT = function () {
  return process.env.NODE_ENV;
}();